import React from "react";
import { Box, Card, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        borderBottom: "1px solid #EAECF0",
    },
    [`&.${tableCellClasses.body}`]: {
        borderBottom: "1px solid #EAECF0",
    },
}));

const DataTable = ({ columns, data, ...rest }) => {
    const [selectedId, setSelectedId] = React.useState(data?.length > 0 ? data[0].id : "");
    const handleRowClick = (row, index) => {
        setSelectedId(row.id);
        if (rest.onSelect) {
            rest.onSelect(row, index);
        }
    };
    const renderHeader = (hideHeader) => {
        if (!hideHeader) {
            return (
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <StyledTableCell>{column.name}</StyledTableCell>
                        ))}
                    </TableRow>
                </TableHead>
            );
        };
    };
    return (
        <Card
            {...rest}
            sx={{
                boxShadow: "0px -1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)",
                overflow: "auto",
            }}
        >
            <Box sx={{ minWidth: 450 }}>
                <Table stickyHeader>
                    {renderHeader(rest.hideHeader)}
                    <TableBody>
                        {data.map((row, index) => (
                            <TableRow
                                hover
                                key={row.id}
                                onClick={() => handleRowClick(row, index)}
                                sx={{
                                    background:
                                        row.id === selectedId && !rest.disableSelected ? "#CFF9FE !important" : "",
                                }}
                            >
                                {columns.map((column) => (
                                    <StyledTableCell key={column.id + row.id}>{column.selector(row)}</StyledTableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        </Card>
    );
};

export { DataTable };
